export const enum AgentListCommonStrategyEvent {
  updateAgentCards = 'update-agent-cards',
}
